import { orderBy } from 'lodash'
import moment from 'moment-timezone'

export const getDefaultTimezone = (confTimezone) =>
  confTimezone ? confTimezone : 'America/Los_Angeles'

export const convertTimestampToLocalString = (timestamp, timezone, is24hrFormat) => {
  const format = is24hrFormat ? 'M/D/YYYY HH:mm' : 'M/D/YYYY h:mm A'
  return moment(timestamp).tz(getDefaultTimezone(timezone)).format(format)
}

export const formatTimestamp = (dateFormat, timestamp, timezone, is24hrFormat) => {
  const format = is24hrFormat ? `${dateFormat} HH:mm` : `${dateFormat} h:mm A`
  return moment(timestamp).tz(getDefaultTimezone(timezone)).format(format)
}

export const sortDataArrayByCreatedAt = (data = [], order = 'asc') => {
  return orderBy(
    data,
    [(item) => item?.startDate || '', (item) => item.createdAt || ''],
    [order, order]
  )
}

// Format the created date based on how long ago it was created
export const formatCreatedAt = (timestamp) => {
  if (!timestamp) return ''

  const now = moment()
  const createdTime = moment(timestamp)
  const monthsAgo = now.diff(createdTime, 'months')

  if (monthsAgo > 0) {
    return createdTime.format('MMM DD, YYYY hh:mm A')
  } else {
    return createdTime.fromNow()
  }
}
